module.exports = __webpack_public_path__ + "static/media/02_game_over.ac519535.jpg";